export const pathAssetsBase: string = import.meta.env.VITE_APP_PATH_ASSETS_NEW ||
    'https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/'
export const pathAssets = `${pathAssetsBase}100m`
export const pathAssetsJavelin = `${pathAssetsBase}javelin`
export const pathAssetsGlobal = `${pathAssetsBase}global`
export const pathAssetsCoreUi = 'https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui'
